import { MaskedLines, Reveal } from "@/components/motion/Reveal";
import { motion, useReducedMotion } from "framer-motion";
import { EASE } from "@/components/motion/Reveal";

export function PageHero({ label, title, lead, image, imageAlt = "", children, light = false }) {
  const reduced = useReducedMotion();
  return (
    <section className={`relative ${image ? "min-h-[78svh] text-paper bg-ink" : "bg-paper text-ink pt-40 pb-20"} flex items-end overflow-hidden`}>
      {image && (
        <>
          <motion.img
            src={image}
            alt={imageAlt}
            sizes="100vw"
            fetchPriority="high"
            className="absolute inset-0 w-full h-full object-cover"
            initial={reduced ? false : { scale: 1.15 }}
            animate={{ scale: 1.03 }}
            transition={{ duration: 2.2, ease: EASE }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-ink/60 via-ink/20 to-ink/85" />
        </>
      )}
      <div className={`relative z-10 container-x w-full ${image ? "pt-44 pb-16 md:pb-24" : ""}`}>
        {label && (
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.5 }} className={`label mb-8 flex items-center gap-4 ${image ? "text-paper/60" : "text-mute"}`}>
            <span className={`w-6 h-px ${image ? "bg-paper/50" : "bg-ink/40"}`} /> {label}
          </motion.p>
        )}
        <MaskedLines as="h1" inView delay={0.3} lines={title} data-testid="page-title" className="display text-4xl sm:text-5xl lg:text-6xl xl:text-[5.5rem] max-w-[14ch]" />
        {lead && (
          <Reveal delay={0.7} className="mt-10 grid md:grid-cols-12 gap-8">
            <p className={`md:col-span-6 lg:col-span-5 text-base md:text-lg leading-relaxed ${image ? "text-paper/80" : "text-mute"}`}>{lead}</p>
            {children && <div className="md:col-span-6 lg:col-span-7 flex md:justify-end items-end">{children}</div>}
          </Reveal>
        )}
      </div>
    </section>
  );
}
